const ACTION_COLORS = {
  USER: '#3b82f6', PROJECT: '#8b5cf6', PAGE: '#f59e0b',
  PLANNING: '#10b981', ASSEMBLY: '#ec4899', RESOURCE: '#06b6d4',
};

const getActionColor = (action) => {
  const key = Object.keys(ACTION_COLORS).find(k => action?.includes(k));
  return key ? ACTION_COLORS[key] : 'var(--pico-muted-color)';
};

const formatRelativeTime = (ts) => {
  if (!ts) return '';
  const diff = Date.now() - ts;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(ts).toLocaleDateString([], { month: 'short', day: 'numeric' });
};

const ActivityMiniFeed = ({ logs = [] }) => {
  if (logs.length === 0) {
    return <p className="home-chart-empty" style={{ padding: '1.5rem 0' }}>No recent activity</p>;
  }

  return (
    <div className="home-mini-feed">
      {logs.slice(0, 5).map(log => (
        <div key={log.id} className="home-mini-entry">
          <span className="home-mini-dot" style={{ background: getActionColor(log.action) }} />
          <div className="home-mini-content">
            <span className="home-mini-action" style={{ color: getActionColor(log.action) }}>
              {log.action?.replace(/_/g, ' ')}
            </span>
            <span className="home-mini-actor">{log.actorEmail || '—'}</span>
          </div>
          <span className="home-mini-time">{formatRelativeTime(log.timestamp)}</span>
        </div>
      ))}
    </div>
  );
};

export default ActivityMiniFeed;
